<template lang="pug">
  LineChart#my-wellness-metric-chart(
    :chart-data="chartData"
  )
</template>

<script>
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import LineChart from "@/charts/LineChart";

export default {
  name: "WellnessMetricChart",

  components: {
    LineChart
  },

  mixins: [dateUtilityMixin],

  props: {
    daysInChart: {
      type: Number,
      default: 7
    },

    metricType: {
      type: String,
      default: ""
    }
  },

  computed: {
    ...mapGetters("members", ["wellnessChartData"]),

    chartData: {
      get() {
        const dateRange = [...Array(this.daysInChart)].map((_, index) => {
          const date = this.date(this.moment().subtract(index, "day"))
            .formatted;

          const defaultObj = {
            value: 0,
            date: date
          };

          const entry = this._.find(this.wellnessChartData, { date: date });

          return entry === undefined ? defaultObj : entry;
        });

        const labels = dateRange
          .map(day => this.moment(day.date).format("MMM DD"))
          .reverse();

        //Manipulating the value based on if it's a sleep metric or not
        const dataMetrics =
          this.metricType === "sleep"
            ? dateRange.map(day => (day.value / 60).toFixed(2)).reverse()
            : dateRange.map(day => Math.round(day.value)).reverse();

        const color = this.determineColor;

        const datasets = [
          {
            label: this._.upperFirst(this.metricType),
            borderColor: color,
            backgroundColor: "transparent",
            pointBorderWidth: 3,
            pointRadius: 6,
            data: dataMetrics
          }
        ];
        return { labels, datasets };
      },
      set(data) {
        return data;
      }
    }
  },

  methods: {
    determineColor() {
      if (this.metricType === "sleep") {
        this.color = "#1c3260";
      } else if (this.metricType === "mood") {
        this.color = "#56c0e2";
      } else if (this.metricType === "nutrition") {
        this.color = "#df2100";
      } else if (this.metricType === "water") {
        this.color = "#4494f7";
      } else if (this.metricType === "heart") {
        this.color = "#da0051";
      } else if (this.metricType === "mindfulness") {
        this.color = "#8dba47";
      } else if (this.metricType === "weight") {
        this.color = "#2b646e";
      }
      return this.color;
    }
  }
};
</script>

<style lang="sass" scoped></style>
